export default __webpack_public_path__ + "static/ibis-styles-5d231c941daf1c55ed80fc2f19dab9ab.png";